import { Fragment, useState } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";

import ChevronDown from "~/icons/ChevronDown";
import styles from "./FilterDropdown.module.css";

interface Option {
  value: string | null;
  label: string;
}

interface FilterDropdownProps {
  placeholder?: string;
  prefixIcon?: React.ReactNode;
  options: Option[];
  value: string | null | undefined;
  onChange: (value: string | null) => void;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  placeholder = "Select an option",
  prefixIcon,
  options,
  value,
  onChange,
}) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const selectedLabel = value
    ? options.find((opt) => opt.value === value)?.label || placeholder
    : placeholder;

  return (
    <Menu as="div" className={styles.container}>
      <MenuButton className={styles.button}>
        {prefixIcon && <span className={styles.icon}>{prefixIcon}</span>}
        <span>{selectedLabel}</span>
        <span className={styles.icon}>
          <ChevronDown />
        </span>
      </MenuButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className={styles.menuItems}>
          <div className={styles.menuList}>
            {options.map((option) => (
              <MenuItem key={option.value}>
                {() => (
                  <div
                    onClick={() => onChange(option.value)}
                    onMouseEnter={() => setHoveredItem(option.value)}
                    onMouseLeave={() => setHoveredItem(null)}
                    className={`${styles.menuItem} ${
                      hoveredItem === option.value ? styles.menuItemHovered : ""
                    }`}
                  >
                    <span className={styles.itemLabel}>{option.label}</span>
                    <div className={styles.radioButton}>
                      {value === option.value && (
                        <div className={styles.radioButtonInner} />
                      )}
                    </div>
                  </div>
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
};

export default FilterDropdown;
